import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeMessage } from "../../redux/actions/messageActions";
import { Button, notification } from 'antd';
const MessageView = () => {
  const dispatch = useDispatch();
  const messages = useSelector((state) => state.message.messages);
  const [api, contextHolder] = notification.useNotification();
  const displayedMessages = useRef(new Set());

  const onClose =(flagId)=>{
    displayedMessages.current.delete(flagId);
    dispatch(removeMessage(flagId));
  }

  useEffect(() => {
    messages.forEach(flag => {
      if (displayedMessages.current.has(flag.id)) {
        return;
      }
      displayedMessages.current.add(flag.id);
      api.open({
        message: flag.title,
        description:flag.description,
        duration: 5,
        icon: flag.icon,
        onClose: ()=>onClose(flag.id)
      });
    });
  }, [messages, api]);
 
  return (
    <div style={{ marginBottom: "10px" }}>
        {contextHolder}
    </div>
  );
};
export default MessageView;
